// extracted by mini-css-extract-plugin
export var completionBody = "_cb-2";
export var completionCard = "_cb-0";
export var completionFooter = "_cb-3";
export var completionTitle = "_cb-1";